import satellite from "./sat/satellite";
import plugincode from "./sat/satellite";

export default satellite;
export {plugincode} from "./sat/satellite";
